<template>
  <div class="common-table">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="10" type="flex">
            <a-col>
              <a-form-item label="Query" style="width:230px;">
                <a-input v-model="queryParam.name" placeholder="Name / Number" @keyup.enter.stop="refreshCurrentPage"/>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item label="Gender" style="width:150px;">
                <a-select v-model="queryParam.gender" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                  <a-select-option value="">All</a-select-option>
                  <a-select-option value="M">Male</a-select-option>
                  <a-select-option value="F">Female</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item label="Company" style="width:160px;">
                <a-select v-model="queryParam.companyCode" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                  <a-select-option value="">All</a-select-option>
                  <a-select-option v-for="i in companyList" :key="'company-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col>
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = { name: '', gender: '', companyCode: '' }">Clear</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

      <!-- <div class="table-operator">
        <a-button type="primary" icon="plus" @click="handleEdit()" :disabled="!$auth('CDB_CUSTOMER_ADD')">New</a-button>
      </div> -->
    <a-card :bordered="false">
      <s-table
        style="display: table;"
        ref="table"
        size="default"
        rowKey="id"
        showQuickJumper
        :columns="columns"
        :data="loadData"
      >
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <!-- signet -->
        <span slot="joinTourTotal" slot-scope="text, record">
          <span>{{ record.joinTourTotal}}<span v-if="record.signetCustomerCode">/</span>{{ record.joinTourCancelTotal}}</span>
        </span>
        <!-- supera -->
        <span slot="superaJoinTourTotal" slot-scope="text, record">
          <span>{{ record.superaJoinTourTotal}}<span v-if="record.superaCustomerCode">/</span>{{ record.superaJoinTourCancelTotal}}</span>
        </span>
        <div slot="writeDate" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <div style="font-weight:500;margin-right: 6px;">{{ record.changeBy.userName }}</div>
              <div>{{ DateTimeUtil().localString(record.writeDate !== null ? record.writeDate : record.createDate) }}</div>
            </template>
            <div>
              <div>
                {{ DateTimeUtil().utcString(record.writeDate !== null ? record.writeDate : record.createDate, 'MM/DD/YYYY') }}
              </div>
            </div>
          </a-tooltip>
        </div>
        <div slot="fullName" slot-scope="text">
          {{ text ? text.replace(/,/g, ', ') : ''}}
        </div>

        <span slot="action" slot-scope="text, record">
          <template>
            <a-popconfirm
              title="Are you sure delete?"
              @confirm="handleRecovery(record)"
              okText="Yes"
              cancelText="No"
            >
              <a href="javascript:;" :disabled="!$auth('CDB_CUSTOMER_TRASH')" :loading="recoveryLoading">Recovery</a>
            </a-popconfirm>
            <!-- <a-divider type="vertical" />
            <a href="javascript:;"><a @click="showMergeToModal(record)">Merge To</a></a> -->
          </template>
        </span>
      </s-table>
      <a-modal
        title="Merge Join Tour Record To Other Customer"
        :visible="mergeToRecord !== null"
        :confirm-loading="mergeToLoading"
        @ok="handleMergeToConfirm"
        @cancel="handleMergeToCancel"
        :width="400"
      >
        <a-form-model
          ref="mergeToForm"
          :model="mergeToForm"
          :rules="mergeToRules"
        >
          <a-form-model-item label="Customer code" prop="targetCustomerCode">
            <a-input placeholder="Customer Number" v-model="mergeToForm.targetCustomerCode"/>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import '@/assets/css/common-table-list.css'
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import CDBApi from '@/api/api-cdb-custome-v2'
import { Company } from '@/utils/helper/standard-code-utils'

export default {
  name: 'CdbCustomerList',
  components: {
    STable
  },
  data () {
    return {
      companyList: Company.dict,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { name: '', gender: '', companyCode: '' },
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '35px',
          align:'center'
        },
        {
          title: 'Number',
          dataIndex: 'globalCode',
          align:'center'
        },
        {
          title: 'Name',
          dataIndex: 'fullName',
          scopedSlots: { customRender: 'fullName' },
        },
        {
          title: 'Gender',
          dataIndex: 'gender',
          customRender: (value) => (value === 'M') ? 'Male' : 'Female',
          align:'center'
        },
        {
          title: 'DOB',
          dataIndex: 'birthday',
          customRender: (value) => this.dateFormatB(value),
          align:'center'
        },
        {
          title: 'Signet#',
          dataIndex: 'signetCustomerCode',
          align: 'center',
          width: '95px'
        },
        {
          title: 'Signet Join',
          dataIndex: 'joinTourTotal',
          align: 'center',
          width: '90px',
          scopedSlots: { customRender: 'joinTourTotal' }
        },
        {
          title: 'Supera#',
          dataIndex: 'superaCustomerCode',
          align: 'center',
          width: '95px'
        },
        {
          title: 'Supera Join',
          dataIndex: 'superaJoinTourTotal',
          align: 'center',
          width: '90px',
          scopedSlots: { customRender: 'superaJoinTourTotal' }
        },
        // {
        //   title: 'Change By',
        //   dataIndex: 'changeBy',
        //   customRender: (value) => value ? value.userName : ''
        // },
        // {
        //   title: 'Change Time',
        //   dataIndex: 'writeDate',
        //   customRender: (value, record) => this.DateTimeUtil().localString(value !== null ? value : record.createDate)
        // },
        {
          title: 'Last Modified',
          dataIndex: 'writeDate',
          scopedSlots: { customRender: 'writeDate' },

        },
        {
          title: '',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return CDBApi.queryTrash(Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      recoveryLoading: false,
      // 合并团操作
      labelCol: { span: 7 },
      wrapperCol: { span: 12 },
      mergeToRecord: null,
      mergeToLoading: false,
      mergeToForm: { targetCustomerCode: null },
      mergeToRules: {
        targetCustomerCode: [{ required: true, message: 'Please input target customer code.' }],
      },
    }
  },
  created () {
  },
  methods: {
    async handleRecovery (record) {
      this.recoveryLoading = true
      try {
        const res = await CDBApi.recovery(record.id)
        if (!this.mixinProcessHasBizErrorNotification(res)) {
          this.refreshCurrentPage()
          this.mixinProcessSuccessNotification('Save successfully !')
        }
        this.recoveryLoading = false
      } catch(e) {
        console.log(e)
        this.recoveryLoading = false
      }
    },
    // 合并团操作
    showMergeToModal (record) {
      this.mergeToRecord = record
      this.mergeToForm = { targetCustomerCode: null }
    },
    handleMergeToConfirm () {
      this.$refs.mergeToForm.validate(async (valid) => {
        if (valid) {
          this.mergeToLoading = true
          try {
            const res = await CDBApi.mergeJoinToOtherCustomer(this.mergeToRecord.id, this.mergeToForm.targetCustomerCode)
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Merge successfully !')
              this.refreshCurrentPage()
              this.handleMergeToCancel()
            }
            this.mergeToLoading = false
          } catch (e) {
            this.mergeToLoading = false
            if (e && e.response && e.response.data) {
              this.$notification['error']({
                message: 'Error',
                description: `${e.response.data.errorMessage}`
              })
            }
          }
        }
      })
    },
    handleMergeToCancel () {
      this.mergeToRecord = null
      this.mergeToForm = { targetCustomerCode: null }
    },
    //
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
<style lang="less" scoped>
.overflow-hidden{
  width: 100%;
  position: relative;
  text-align: left;
}
.overflow-hidden > div{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  left: 0;
}
::v-deep .ant-table-tbody > tr > td {
  vertical-align: top;
}
</style>